import { render, staticRenderFns } from "./MessengerSetting.vue?vue&type=template&id=0e0bf189&scoped=true"
import script from "./MessengerSetting.vue?vue&type=script&lang=js"
export * from "./MessengerSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0bf189",
  null
  
)

export default component.exports